"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComposedLabels = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("@suezenv/react-theme-components/assets/css/main.css");

require("./ComposedLabels.scss");

var clsx_1 = __importDefault(require("clsx"));

var defaultClasses = 'mb-0 d-inline';
var defaultProps = {
  variant: 'caption',
  color: 'disabled',
  weight: 'medium'
};

exports.ComposedLabels = function (_a) {
  var labels = _a.labels,
      className = _a.className,
      props = __rest(_a, ["labels", "className"]);

  return react_1.default.createElement("div", {
    className: "info-users mb-3"
  }, labels === null || labels === void 0 ? void 0 : labels.map(function (label, index) {
    return react_1.default.createElement(react_theme_components_1.SzTypographie, __assign({
      key: index
    }, defaultProps, props, {
      className: clsx_1.default(defaultClasses, className, {
        'pr-2': index === 0,
        'px-2': index > 0,
        'border-right': labels.length - 1 > index
      })
    }), label);
  }));
};

exports.default = exports.ComposedLabels;